import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as enumValueType from './enum-value-type'
import * as filesValueType from './files-value-type'
import * as inlineEnumValueType from './inline-enum-value-type'
import * as intrinsicValueType from './intrinsic-value-type'
import * as multiReferenceValueType from './multi-reference-value-type'
import * as referenceValueType from './reference-value-type'
import * as structureValueType from './structure-value-type'

export const DOC = gql`
  ${enumValueType.DOC}
  ${filesValueType.DOC}
  ${inlineEnumValueType.DOC}
  ${intrinsicValueType.DOC}
  ${multiReferenceValueType.DOC}
  ${referenceValueType.DOC}
  ${structureValueType.DOC}
  fragment FragmentDmsValueType on DmsValueType {
    __typename
    ...FragmentDmsEnumValueType
    ...FragmentDmsFilesValueType
    ...FragmentDmsInlineEnumValueType
    ...FragmentDmsIntrinsicValueType
    ...FragmentDmsMultiReferenceValueType
    ...FragmentDmsReferenceValueType
    ...FragmentDmsStructureValueType
  }
`
export const TRANSFORMER = graphql.transformers.OUT.discriminateOn<
  graphql.schema.FragmentDmsValueTypeFragment,
  ents.core.dms.data.Value.Type,
  '__typename'
>('__typename', {
  DmsEnumValueType: enumValueType.TRANSFORMER,
  DmsFilesValueType: filesValueType.TRANSFORMER,
  DmsInlineEnumValueType: inlineEnumValueType.TRANSFORMER,
  DmsIntrinsicValueType: intrinsicValueType.TRANSFORMER,
  DmsMultiReferenceValueType: multiReferenceValueType.TRANSFORMER,
  DmsReferenceValueType: referenceValueType.TRANSFORMER,
  DmsStructureValueType: structureValueType.TRANSFORMER,
})
